module.exports = __webpack_public_path__ + "img/2_172.48c0bd3e.png";